import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { modalTypes } from 'reduxStore/reducers/compCtrl'
import './AdminLoginModal.scss'
import { controlModalAction } from 'reduxStore/actions'

const AdminLoginModal = () => {
  const dp = useDispatch()
  const { admin, compCtrl } = useSelector(state => state)

  const {
    [modalTypes.ADMIN]: { active },
  } = compCtrl


  const handleOnBackgroundClick = useCallback(
    /**
     * @param {MouseEvent} e
     */
    e => {
      dp(controlModalAction(controlModalAction.modalTypes.ADMIN, false))
    },
    [dp],
  )

  const handleOnButtonClick = useCallback(() => {
    dp(controlModalAction(controlModalAction.modalTypes.ADMIN, true))
  }, [dp])

  return active ? (
    <div
      onClick={handleOnBackgroundClick}
      className='AdminLoginModalBackground'
    >
      <div
        onClick={e => e.stopPropagation()}
        className='AdminLoginModalContainer'
      >
        <div className='AdminLoginModalContent'>AdminLoginModal</div>
      </div>
    </div>
  ) : (
    <button onClick={handleOnButtonClick} className='AdminLoginModalButton'>
      Admin
    </button>
  )
}

export default AdminLoginModal
